<template>
  <header class="adm-head">
    <h1 class="adm-head__title">{{ pageTitle }}</h1>
    <div class="adm-head__user">
      <div class="adm-head__avatar-wrap" aria-hidden="true">
        <img class="adm-head__avatar" :src="sliceMenu('account.png')" alt="" />
      </div>
      <div class="adm-head__meta">
        <span class="adm-head__role">系统管理员</span>
        <span class="adm-head__id">{{ nickLine }}</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AdminHeader',
  computed: {
    pageTitle() {
      const hit = this.$route.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.title)
      return (hit && hit.meta.title) || '账户总览'
    },
    nickLine() {
      return this.localNick || '—'
    }
  },
  data() {
    return {
      localNick: ''
    }
  },
  mounted() {
    this.syncNick()
  },
  watch: {
    $route() {
      this.syncNick()
    }
  },
  methods: {
    syncNick() {
      const n = sessionStorage.getItem('admin_nickname')
      this.localNick = n != null && String(n).trim() !== '' ? String(n).trim() : ''
    },
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceMenu(name) {
      return this.base() + 'slices/menu/' + encodeURIComponent(name)
    }
  }
}
</script>

<style lang="scss" scoped>
.adm-head {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(203, 213, 225, 0.65);
  box-sizing: border-box;
}

.adm-head__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.adm-head__user {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.adm-head__avatar-wrap {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #dbeafe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.adm-head__avatar {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.adm-head__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 200px;
  min-width: 0;
  line-height: 1.3;
  gap: 2px;
}

.adm-head__role {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adm-head__id {
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
